import React from 'react'
import {BrowserRouter as Router,Switch,Route,Link} from 'react-router-dom';
// import HomeLogin from "./Pages/login/Home"
import Landingpage from "./Components/Landingpage"
import Malls from './Components/Malls';
import NewsPage from './Components/NewsPage';
import Restaurants from "./Components/Restaurants";
function Routes() {
    return (
        <Router>
            <Switch>
                {/* <Route path="/" exact render={()=>{return(<HomeLogin />)}} /> */}
                <Route path="/" exact render={()=>{return(<Landingpage />)}} />
                <Route path="/news" exact render={()=>{return(<NewsPage />)}} />
                <Route path="/restaurant" exact render={()=>{return(<Restaurants />)}} />
                <Route path="/malls" exact render={()=>{return(<Malls />)}} />
            </Switch>
        </Router>
    )
}

export default Routes
